import { faFolderPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../../common';

type CreateSubfolderPropsType = {
  onClick: () => void;
  disabled?: boolean;
};

export const CreateSubfolder: React.FC<CreateSubfolderPropsType> = ({
  onClick,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      leftSection={<FontAwesomeIcon icon={faFolderPlus} />}
      onClick={onClick}
      disabled={disabled}
    >
      {t('FILE_TREE_CONTEXT_MENU.CREATE_SUBFOLDER')}
    </MenuItem>
  );
};
